// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_7644438b","outerContainer":"e5823785","secondaryToolbar":"_0eaef895","doorHangerRight":"ef7edde9","toolbarContainer":"_539cc938","toolbarViewerMiddle":"_2f1a04e8","progressBar":"_63f5b4ca","back-to-application":"df7be095","root":"b444e753","full":"f58ffa60","collapsed":"d4aa7e23","disabled":"_8b4921e1","main":"_12d2a4a2","title":"cf447437","logo":"cde8869d","info":"_7578d8e3","text":"_584274cf","infoBtn":"_99a88e11","btn":"_287f91db","desc":"_3e4dc02c","descText":"c5c07f4e","descLink":"f26c4f21","deviceSettings":"ddbebd7d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/Components/VisitHeader/styles.styl
// module id = 5166
// module chunks = 39